import { InitiativeStatusType } from 'types/entities/initiative';
import { styled } from 'styled-components';

export type BadgeVariant = 'success' | 'error' | 'warning' | 'info' | 'neutral';

export const BadgeContainer = styled.span<{ $variant?: BadgeVariant }>`
  display: inline-block;
  padding: ${({ theme }) => theme.sizes.xs} ${({ theme }) => theme.sizes.sm};
  border-radius: 999px;
  font-size: ${({ theme }) => theme.sizes['2xs']};
  font-weight: 400;
  width: fit-content;
  background-color: ${({ theme, $variant }) =>
    $variant === 'success'
      ? theme.colors.green100
      : $variant === 'error'
        ? theme.colors.red100
        : $variant === 'warning'
          ? theme.colors.secondary100
          : $variant === 'info'
            ? theme.colors.blue100
            : theme.colors.neutral200};
  color: ${({ theme, $variant }) =>
    $variant === 'success'
      ? theme.colors.green700
      : $variant === 'error'
        ? theme.colors.red700
        : $variant === 'warning'
          ? theme.colors.secondary700
          : $variant === 'info'
            ? theme.colors.blue700
            : theme.colors.neutral800};
`;
